
import Vue, { PropType } from 'vue';

import Input from '~/components/builders/Base/Input.vue';
import Button from '~/components/builders/Base/Button.vue';
import VerifiedBadge from '~/assets/img/verifiedBadge.png';
import CandidateService from '~/services/CandidateService';
import { commonProps, setupBuilder } from '~/utils/candidate';
import { CandidateJobBuilder } from '~/utils/candidate/CandidateJobBuilder';

export default Vue.extend({
    name: 'WelcomeStartPage',
    components: {
        Button,
        Input,
    },
    props: {
        isNewUser: {
            type: Boolean,
            default: true,
        },
        askForName: {
            type: Boolean,
            default: true,
        },
        clickNext: {
            type: Function,
            default: () => {},
        },
        error: {
            type: Function,
            default: () => {},
        },

        ...commonProps(),
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),

            fname: '',
            lname: '',

            isLoading: false,

            VerifiedBadge,
        };
    },
    computed: {
        isFormValid(): boolean {
            return Boolean(this.fname && this.lname);
        },
    },
    methods: {
        async handleNext() {
            if (!this.builder || this.builder.isEmpty()) {
                this.$emit('clickNext');
                return;
            }

            const request = this.builder.buildRequest();

            this.isLoading = true;
            this.service
                .updateCandidateProfile(request)
                .then(() => {
                    this.isLoading = false;
                    this.$emit('clickNext');
                })
                .catch(err => {
                    this.$emit('error', err);
                })
                .finally(() => {
                    this.isLoading = false;
                });

            this.builder.reset();
        },
    },
    mounted() {
        this.builder = setupBuilder.apply(this);

        this.fname = this.builder.getUserField('firstName') || '';
        this.lname = this.builder.getUserField('lastName') || '';

        this.$watch('fname', this.builder.watchUser('firstName'));
        this.$watch('lname', this.builder.watchUser('lastName'));
    },
});
